import Helper from "../../src/support/Helper";
import HCLDX from "@system/config/hcldx";
import System from "../../src/helper/system";

class Auth {
    static LOGIN_VALIDATE = Helper.getBaseUrl() + `/api/auth/validate`;
    static FORGOT_PASSWORD = Helper.getBaseUrl() + `/api/user/forgotpassword`;
    static CHANGE_PASSWORD = Helper.getBaseUrl() + `/api/user/changepassword`;
    static SHIPPING_ADDRESS = Helper.getBaseUrl() + `/api/user/shippingAddress`;
    static CUSTOMER_SCOPED_INFORMATION = Helper.getBaseUrl() + '/api/customer/details';
    static MAKE_SHIPPING_ADDRESS_DEFAULT = Helper.getBaseUrl() + `/api/user/shippingAddress/makeDefault`;
    static SAVE_USER_PREFRENCE_URL = Helper.getBaseUrl() + `/api/user/saveUserPreference`;
    static REGISTER_USER_URL = Helper.getBaseUrl() + `/api/user/adduser`;
    static GET_COUNTRY_LIST = Helper.getBaseUrl() + `/api/user/getAllCountries`;
    static USER_VERIFICATION_URL = Helper.getUserUrl() + `/api/user/reverify`;
    static SEARCH_CROSS_REFERENCE_PARTS_URL = Helper.getDesignHubUrl() + '/api/designhub/searchCrossReferenceParts';
    static getUserUUID() {
        return this.getUserID();
    }

    static getUserID() {
        if (System.auth('userID')) {
            return System.auth('userID');
        }
        return '';
    }

    static getUserName() {
        if (System.auth('firstName')) {
            return System.auth('firstName') + ' ' + System.auth('lastName');
        }
        return '';
    }

    static getEmail() {
        if (System.auth('email')) {
            return System.auth('email');
        }
        return '';
    }

    static getCountryCode() {
        if (System.auth('billToCountryCode')) {
            return System.auth('billToCountryCode');
        }
        return '';
    }

    static getAccountNumber() {
        if (System.auth('accountNumber')) {
            return System.auth('accountNumber');
        }
        return '';
    }

    static getAccountName() {
        if (System.auth('accountName')) {
            return System.auth('accountName');
        }
        return '';
    }

    static getAccountDescription() {
        if (System.auth('speedboatDescription')) {
            return System.auth('speedboatDescription');
        }
        return '';
    }
    static getAuthSBoat() {
        if (System.auth('speedBoat')) {
            return System.auth('speedBoat');
        }
        return '';
    }

    static getLoginPageRouteURL() {
        return HCLDX.baseURL() + '/authenticate/login';
    }

    static getForgotPasswordPageRouteURL() {
        return HCLDX.baseURL() + '/authenticate/forgot/password';
    }

    static getResetPasswordPageRouteURL() {
        return HCLDX.baseURL() + '/authenticate/reset-password';
    }

    static getCrossReferenceToolRouteURL() {
        return HCLDX.baseURL() + '/solutions/product-and-solutions-design/design-hub/crossreferencetool';
    }

    static defaultGuestAuth() {
        return {
            "firstName": "",
            "lastName": "",
            "email": "",
            "userID": "",
            "account": {
                "accountName": "",
                "accountNumber": "",
                "speedBoat": "",
                "salesOrg": "",
                "defaultAccount": false,
                "accountCurrency": null,
                "roles": []
            }
        };
    }
}

export default Auth;
